import { Button, Stack, Text } from '@chakra-ui/react'

import useAPIWrapper from '@/client/hooks/useAPIWrapper'
import { RPCRefresh } from '@/client/rpc'

import ModalV3 from '@/components/UI/Modal/ModalV3'

export default function CancelGivingLiveHelpModal({
  postId,
  open,
  onClose,
}: {
  postId: number
  open: boolean
  onClose: () => void
}): JSX.Element {
  const [handleCancelRequest, isCancelling] = useAPIWrapper(
    async () => {
      await RPCRefresh.cancelGivingLiveHelp({
        postId,
      })
      onClose()
    },
    [postId, onClose],
    'Cancel Giving Live Help'
  )

  return (
    <ModalV3
      size="xl"
      open={open}
      onClose={onClose}
      title="Cancel giving Zoom help"
      body={() => <Text>Are you sure you want to cancel giving Zoom help?</Text>}
      rightFooterContent={() => (
        <Stack direction="row" spacing="8px">
          <Button variant="outline" onClick={onClose}>
            No, Continue
          </Button>
          <Button isLoading={isCancelling} variant="danger" onClick={handleCancelRequest}>
            Yes, Cancel
          </Button>
        </Stack>
      )}
    />
  )
}
